import { SkyscannerPlaceholderserviceV1PlaceholderService } from '@skyscanner-internal/placeholder-service-web-http-client';

import { grpcFetchClientWrapper } from '../internals/clients/grpc/grpc';

const PLACEHOLDER_SERVICE_CLIENT_NAME = 'PLACEHOLDER_SERVICE';

export const placeholderServiceGetPlaceholdersRequest = grpcFetchClientWrapper(
  SkyscannerPlaceholderserviceV1PlaceholderService.PlaceholderService.GetPlaceholders,
  {
    clientName: PLACEHOLDER_SERVICE_CLIENT_NAME,
    pathPrefix: '/g/placeholder',
  },
);
